import { Pipe, PipeTransform } from "@angular/core";
/**
 * 반올림 pipe
 */
@Pipe({
  name: 'chemiScore'
})
export class ChemiScorePipe implements PipeTransform {

  transform(value?: number): number | undefined {
    if (value !== undefined) {
      return Math.min(value, 99);
    }
    return;
  }
}
